import Rails from "@rails/ujs"
import { Collapse } from "bootstrap"
// import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "controllers"
import "site"

Rails.start()
// ActiveStorage.start()
